<template>
  <div class="partsDetail-container" v-loading.fullscreen.lock="fullscreenLoading">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <div class="card-title">
            部件详细
          </div>
          <div class="card-content" v-loading="loading">
            <div>
              <span style="color:#99a9bf">生产单号：</span>
              <span style="color:#409EFF;font-weight: 500">{{orderinfo.produnum}}</span>
              <span style="color:#99a9bf;margin-left: 20px">订单号：</span>
              <span>{{orderinfo.ordernum}}</span>
              <span style="color:#99a9bf;margin-left: 20px">详细地址：</span>
              <span>{{orderinfo.address}}</span>
              <span style="color:#99a9bf;margin-left: 20px">色板来源：</span>
              <span>{{orderinfo.source}}</span>
<!--              <span v-if="orderinfo.source===0">厂部标准色板</span>-->
<!--              <span style="color:#F56C6C" v-if="orderinfo.source===1">客户提供色板</span>-->
<!--              <span style="color:#F56C6C" v-if="orderinfo.source===2">厂部定制色板</span>-->
              <span style="color:#99a9bf;margin-left: 20px">设计师：</span>
              <span>{{orderinfo.designer}}</span>
            </div>
            <div style="margin-top: 20px">
              <span style="color:#99a9bf">接单日期：</span>
              <span>{{orderinfo.receive_time}}</span>
              <span style="color:#99a9bf;margin-left: 20px">拆单日期：</span>
              <span>{{orderinfo.split_time}}</span>
              <span style="color:#99a9bf;margin-left: 20px">排产日期：</span>
              <span>{{orderinfo.schedule_time}}</span>
              <span style="color:#99a9bf;margin-left: 20px">预计交期：</span>
              <span>{{orderinfo.planned}}</span>
            </div>
            <div style="padding-top: 30px;border-top: 1px solid #f5f7fa;margin-top:30px;">
              <el-form :inline="true" size="small" :model="searchForm">
                <el-form-item label="区域">
                  <el-select v-model="searchForm.area" style="width: 120px" filterable clearable>
                    <el-option
                      v-for="item in orderinfo.arealst"
                      :key="item"
                      :label="item"
                      :value="item">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="分类">
                  <el-select v-model="searchForm.type" style="width: 100px" filterable clearable>
                    <el-option
                      v-for="item in orderinfo.typelst"
                      :key="item"
                      :label="item"
                      :value="item">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="状态">
                  <el-select v-model="searchForm.mmark" style="width: 100px" clearable>
                    <el-option label="未包" value="0"></el-option>
                    <el-option label="已包" value="1"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="搜索关键字">
                  <el-input v-model="searchForm.search"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="getMaterialDetail" icon="el-icon-search">搜索</el-button>
                  <el-button icon="el-icon-printer" @click="batchPrint">批量打印</el-button>
                  <el-button icon="el-icon-delete-solid" @click="getDeleteRecord">删除记录</el-button>
                  <el-button icon="el-icon-delete" type="danger" @click="batchDelete">批量删除</el-button>
                </el-form-item>
              </el-form>
              <div v-loading="materialloading" style="height: 490px;width: 100%">
                <pl-table
                  :key="tableKey"
                  height="490px"
                  :datas="materialTableData"
                  :data="materialTableData"
                  use-virtual
                  :pagination-show="false"
                  size="small"
                  :row-height="45"
                  @selection-change="handleSelectionChange">
                  <pl-table-column type="selection" align="center" width="50"></pl-table-column>
                  <pl-table-column prop="bar" :resizable="false" label="条码" show-overflow-tooltip align="center" width="130"></pl-table-column>
                  <pl-table-column prop="area" label="区域" width="90" show-overflow-tooltip :resizable="false"></pl-table-column>
                  <pl-table-column prop="type" :resizable="false" align="center" show-overflow-tooltip width="90" label="分类"></pl-table-column>
                  <pl-table-column prop="xuhao" :resizable="false" align="center" show-overflow-tooltip width="80" label="产品序号"></pl-table-column>
                  <pl-table-column prop="name" :resizable="false" min-width="100" show-overflow-tooltip align="center" label="名称"></pl-table-column>
                  <pl-table-column prop="material" :resizable="false" align="center" show-overflow-tooltip width="90" label="基材"></pl-table-column>
                  <pl-table-column label="规格" width="120" show-overflow-tooltip :resizable="false" align="center">
                    <template slot-scope="scope">
                      <span v-if="scope.row.high!=null&&scope.row.high!=''">{{scope.row.high}}</span>
                      <span v-if="scope.row.high!=null&&scope.row.high!=''">×</span>
                      <span v-if="scope.row.width!=null&&scope.row.width!=''">{{scope.row.width}}</span>
                      <span v-if="scope.row.width!=null&&scope.row.width!=''">×</span>
                      <span v-if="scope.row.ply!=null&&scope.row.ply!=''">{{scope.row.ply}}</span>
                    </template>
                  </pl-table-column>
                  <pl-table-column prop="color" width="100" :resizable="false" show-overflow-tooltip label="颜色" align="center"></pl-table-column>
                  <pl-table-column label="包装状态" :resizable="false" width="90" fixed="right" align="center">
                    <template slot-scope="scope">
                      <el-tag :disable-transitions="true" size="mini" type="danger" v-if="scope.row.mmark===0">未包</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mmark===1">已包</el-tag>
                    </template>
                  </pl-table-column>
                  <pl-table-column label="操作" :resizable="false" fixed="right" width="190" align="center">
                    <template slot-scope="scope">
                      <el-button size="mini" icon="el-icon-printer" @click="print(scope.row)">打印</el-button>
                      <el-button :disabled="scope.row.mmark===1" size="mini" icon="el-icon-delete" @click="deleteRow(scope.$index,scope.row)">删除</el-button>
                    </template>
                  </pl-table-column>
                </pl-table>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="条码删除记录"
      :visible.sync="deleteRecordDialog"
      width="70%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <div style="height: 500px;">
        <pl-table
          v-loading="deleteRecordLoading"
          height="500px"
          :datas="deleteRecord"
          :data="deleteRecord"
          use-virtual
          :pagination-show="false"
          size="small"
          :row-height="45">
          <pl-table-column prop="bar" :resizable="false" label="条码" show-overflow-tooltip align="center" width="130" />
          <pl-table-column prop="area" label="区域" show-overflow-tooltip align="center" :resizable="false" />
          <pl-table-column prop="type" :resizable="false" align="center" show-overflow-tooltip width="90" label="分类" />
          <pl-table-column prop="xuhao" :resizable="false" align="center" show-overflow-tooltip width="80" label="产品序号" />
          <pl-table-column prop="name" :resizable="false" min-width="100" show-overflow-tooltip align="center" label="名称" />
          <pl-table-column prop="material" :resizable="false" align="center" show-overflow-tooltip width="90" label="基材" />
          <pl-table-column label="规格" width="120" show-overflow-tooltip :resizable="false" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.high!==null&&scope.row.high!==''">{{ scope.row.high }}</span>
              <span v-if="scope.row.high!==null&&scope.row.high!==''">×</span>
              <span v-if="scope.row.width!==null&&scope.row.width!==''">{{ scope.row.width }}</span>
              <span v-if="scope.row.width!==null&&scope.row.width!==''">×</span>
              <span v-if="scope.row.ply!==null&&scope.row.ply!==''">{{ scope.row.ply }}</span>
            </template>
          </pl-table-column>
          <pl-table-column prop="color" width="100" :resizable="false" show-overflow-tooltip label="颜色" align="center" />
          <!-- <pl-table-column label="包装状态" :resizable="false" width="90" align="center">
            <template slot-scope="scope">
              <el-tag :disable-transitions="true" size="mini" type="danger" v-if="scope.row.mmark===0">未包</el-tag>
              <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mmark===1">已包</el-tag>
            </template>
          </pl-table-column>-->
          <pl-table-column prop="time" width="150" :resizable="false" label="操作时间" align="center" />
          <pl-table-column prop="userName" width="90" :resizable="false" label="操作人" align="center" />
          <pl-table-column prop="reason" width="130" :resizable="false" label="删除原因" align="center" show-overflow-tooltip />
          <pl-table-column label="操作" width="100" :resizable="false" align="center">
            <template slot-scope="scope">
              <el-button size="mini" icon="el-icon-refresh-right" @click="revertBarcode(scope.row)">还原</el-button>
            </template>
          </pl-table-column>
        </pl-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getErpOrderPartsDetail, getErpOrderBarcodeList, deleteBarcode, getDeleteRecord, revertBarcode, getOrderPartsBarcodePrintUrlNew } from '@/api/erp'
import { getLodop } from '@/common/Lodop/LodopFuncs'

export default {
  name: 'PartsDetail',
  computed: {
    user: getUser
  },
  data() {
    return {
      fullscreenLoading: false,
      orderid: '',
      loading: false,
      tableKey: '',
      materialloading: false,
      materialTableData: [],
      orderinfo: [],
      searchForm: {
        area: '',
        type: '',
        search: '',
        mmark: ''
      },
      multipleSelection: [],
      deleteRecordDialog: false,
      deleteRecordLoading: false,
      deleteRecord: []
    }
  },
  created() {
    this.tempRoute = Object.assign({}, this.$route)
    this.orderid = this.$route.params && this.$route.params.id
    this.getInfo()
  },
  methods: {
    getInfo() {
      this.loading = true
      getErpOrderPartsDetail({ orderid: this.orderid }).then(response => {
        this.orderinfo = response.data
        let pageTitle = ''
        if (this.orderinfo.bid === 3) {
          pageTitle = `部件详细 ${this.orderinfo.ordernum}`
        } else {
          pageTitle = `部件详细 ${this.orderinfo.produnum}`
        }
        document.title = pageTitle
        const route = Object.assign({}, this.tempRoute, { title: pageTitle })
        this.$store.dispatch('tagsView/updateVisitedView', route)
        this.loading = false
        this.getMaterialDetail()
      }).catch(() => {
        this.loading = false
      })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    getMaterialDetail() {
      this.materialTableData = []
      this.multipleSelection = []
      this.materialloading = true
      const data = {
        orderid: this.orderid,
        area: this.searchForm.area,
        type: this.searchForm.type,
        content: this.searchForm.search,
        mmark: this.searchForm.mmark
      }
      getErpOrderBarcodeList(data).then(response => {
        this.tableKey = new Date().getTime()
        this.materialTableData = response.data
        this.materialloading = false
      }).catch(() => {
        this.materialloading = false
      })
    },
    print(row) {
      const LODOP = getLodop()
      if (LODOP !== null && LODOP !== undefined) {
        if (row.bar !== null && row.bar !== '' && row.bar !== undefined) {
          this.SubPrint(row.bar)
        } else {
          this.$message.error('BAR获取失败')
        }
      }
    },
    deleteRow(index, row) {
      if (row.mmark === 1) {
        return false
      } else {
        this.$prompt('请输入删除原因', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /\S/,
          inputErrorMessage: '删除原因不可为空'
        }).then(({ value }) => {
          this.fullscreenLoading = true
          const data = {
            userid: this.user.dUserid,
            obid: row.obid,
            reason: value
          }
          deleteBarcode(data).then(response => {
            this.$message({
              type: 'success',
              message: '删除成功'
            })
            this.materialTableData.splice(index, 1)
            this.fullscreenLoading = false
          })
        }).catch(() => {
          this.fullscreenLoading = false
        })
      }
    },
    batchDelete() {
      if (this.multipleSelection.length === 0) {
        return false
      }
      let packed = 0
      let pack = 0
      let packIds = []
      for (const item of this.multipleSelection) {
        if (item.mmark === 1) {
          packed += 1
        } else {
          pack += 1
          packIds.push(item.obid)
        }
      }
      this.$prompt(`选中${this.multipleSelection.length}项，其中已包${packed}项(不删除)，未包${pack}项，如需继续请输入删除原因`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /\S/,
        inputErrorMessage: '删除原因不可为空'
      }).then(({ value }) => {
        this.fullscreenLoading = true
        const data = {
          userid: this.user.dUserid,
          obid: packIds.join(','),
          reason: value
        }
        deleteBarcode(data).then(response => {
          this.$message({
            type: 'success',
            message: '删除成功'
          })
          this.getMaterialDetail()
          this.fullscreenLoading = false
        })
      }).catch(() => {
        this.fullscreenLoading = false
      })

    },
    batchPrint() {
      const LODOP = getLodop()
      if (LODOP !== null && LODOP !== undefined) {
        if (this.multipleSelection.length > 0) {
          let bars = []
          for (let m of this.multipleSelection) {
            if (m.bar !== null && m.bar !== '' && m.bar !== undefined) {
              bars.push(m.bar)
            }
          }
          if (bars.length > 0) {
            this.SubPrint(bars.join(','))
          } else {
            this.$message.error('未选中要打印的条码')
          }
        } else {
          this.$message.error('未选中要打印的条码')
        }
      }
    },
    getDeleteRecord() {
      this.deleteRecordDialog = true
      this.deleteRecordLoading = true
      getDeleteRecord({ orderid: this.orderid }).then(response => {
        this.deleteRecord = response.data
        this.deleteRecordLoading = false
      }).catch(() => {
        this.deleteRecordLoading = true
      })
    },
    revertBarcode(row) {
      this.$confirm('您确定要恢复这条记录吗?', '提示', {
        confirmButtonText: '是的',
        cancelButtonText: '再想想',
        type: 'warning'
      }).then(() => {
        revertBarcode({ code: row.bar }).then(response => {
          this.$message({
            message: '还原成功',
            type: 'success'
          })
          this.deleteRecordLoading = true
          getDeleteRecord({ orderid: this.orderid }).then(response => {
            this.deleteRecord = response.data
            this.deleteRecordLoading = false
          }).catch(() => {
            this.deleteRecordLoading = true
          })
          this.getMaterialDetail()
        })
      }).catch(() => {
      })
    },
    async SubPrint(bars) {
      const arrbars = bars.split(',')
      const dIDs = [''] // 保存两个ID的数组
      for (let i = 0; i < arrbars.length; i++) {
        if (arrbars[i] !== '') {
          if (dIDs[dIDs.length - 1] === '') {
            dIDs[dIDs.length - 1] = arrbars[i]
          } else {
            if (dIDs[dIDs.length - 1].indexOf(',') > 0) {
              dIDs.push(arrbars[i])
            } else {
              dIDs[dIDs.length - 1] += ',' + arrbars[i]
            }
          }
        }
      }
      const printLoading = this.$loading({
        lock: true,
        text: '正在打印部件条码，请耐心等待',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.7)'
      })
      if (dIDs.length > 500) {
        printLoading.close()
        this.$message.error('数据太多，请区域或分类打印')
      }
      const LODOP = getLodop()
      LODOP.PRINT_INIT('乔金斯部件条码打印')
      LODOP.SET_PRINT_PAGESIZE(1, '93mm', '25mm', '')
      for (var i = 0; i < dIDs.length; i++) {
        LODOP.NewPageA()
        if (dIDs[i].split(',').length === 2) {
          await getOrderPartsBarcodePrintUrlNew({ bar: dIDs[i].split(',')[1] }).then(res => {
            let html_data = res.data.replaceAll('font-size:8pt', 'font-size:7pt')
            LODOP.ADD_PRINT_TABLE(3, '52.5%', '43mm', '25mm', html_data)
          })
        }
        await getOrderPartsBarcodePrintUrlNew({ bar: dIDs[i].split(',')[0] }).then(res => {
          let html_data = res.data.replaceAll('font-size:8pt', 'font-size:7pt')
          LODOP.ADD_PRINT_TABLE(3, '1%', '43mm', '25mm', html_data)
        })
      }
      // LODOP.SET_PRINT_STYLEA(0, 'HtmWaitMilSecs', 100)
      LODOP.PREVIEW()
      printLoading.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.partsDetail-container{

}
</style>
